import React, { useState } from 'react';
import {
  CSSReset,
  Flex,
  ThemeProvider,
  Link as ChakraLink,
  theme,
} from '@chakra-ui/core';
import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import HeaderBar from './components/HeaderBar';
import Content from './components/Content';
import Garage from './components/Garage';
import Navigation from './components/Navigation';
import Race from './components/Race';
import Dealer from './components/Dealer';
import { Provider } from 'react-redux';
import configureStore from './state/configureStore';
import Home from './components/Home';
import Settings from './components/Settings';
import ForcedResetWarning from './components/ForcedResetWarning';
import OfflineEarningsNotification from './components/OfflineEarningsNotification';
import Toasts from './components/Toasts';
import StopRaceModal from './components/StopRaceModal';
import Brand from './components/Brand';
import RaceEvent from './components/RaceEvent';
import Stars from './components/Stars';
import About from './components/About';
import { PageContentContext } from './helpers/context';

const store = configureStore();

const customTheme = {
  ...theme,
  fonts: {
    ...theme.fonts,
    body: `Righteous-Regular, ${theme.fonts.body}`,
    heading: `Righteous-Regular, ${theme.fonts.heading}`,
    mono: `Righteous-Regular, ${theme.fonts.mono}`,
  },
};

const VideoArmorGames = ({ onEnded }) => (
  <ChakraLink
    w="100%"
    h="auto"
    margin="auto"
    href="https://armor.ag/MoreGames"
    isExternal
  >
    <video
      autoPlay
      muted
      preload="auto"
      onEnded={onEnded}
      style={{
        width: '100%',
      }}
    >
      <source src="./video/648x432_v1.m4v" type="video/mp4" />
      <source src="./video/648x432_v1.webm" type="video/webm" />
      <source src="./video/648x432_v1.ogg" type="video/ogg" />
    </video>
  </ChakraLink>
);

function App() {
  const [pageContentRef, setPageContentRef] = useState();
  const [showVideo, setShowVideo] = useState(true);
  const [iframePath, setIframePath] = useState('');

  if (showVideo) {
    return (
      <Flex w="100%" h="100%" position="fixed" bg="black">
        <VideoArmorGames onEnded={() => setShowVideo(false)} />
      </Flex>
    );
  }

  return (
    <ThemeProvider theme={customTheme}>
      <CSSReset />
      <Provider store={store}>
        <BrowserRouter>
          <PageContentContext.Provider
            value={{
              pageContentRef,
              setPageContentRef,
              iframePath,
              setIframePath,
            }}
          >
            <Flex
              direction="column"
              pos="fixed"
              w="100%"
              h="100%"
              top="0"
              left="0"
              bg="grey"
            >
              <HeaderBar />
              <Content flexGrow="1">
                <Switch>
                  <Route path="/garage">
                    <Garage />
                  </Route>
                  <Route path="/race/:event">
                    <RaceEvent />
                  </Route>
                  <Route path="/race">
                    <Race />
                  </Route>
                  <Route path="/dealer/:brand">
                    <Brand />
                  </Route>
                  <Route path="/dealer">
                    <Dealer />
                  </Route>
                  <Route path="/settings">
                    <Settings />
                  </Route>
                  <Route path="/stars">
                    <Stars />
                  </Route>
                  <Route path="/about">
                    <About />
                  </Route>
                  <Route>
                    <Home />
                  </Route>
                </Switch>
              </Content>
              <Navigation />
              <StopRaceModal />
              <Toasts />
              <ForcedResetWarning />
              <OfflineEarningsNotification />
            </Flex>
          </PageContentContext.Provider>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
